import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

/** Dropdown for selecting a method from options: [{ value, label }, ...]. */
export default function MethodSelect({ options, value, onChange, label = 'Method', ...rest }) {
  return (
    <FormControl fullWidth size="small" variant="outlined" {...rest}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={(e) => onChange(e.target.value)} label={label}>
        {options.map((m) => (
          <MenuItem key={m.value} value={m.value}>
            {m.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
